const countries = [
  { name: "United Arab Emirates", code: "+971", iso: "ae", digits: 9, format: [2, 3, 4] },
  { name: "Afghanistan", code: "+93", iso: "af", digits: 9, format: [2, 3, 4] },
  { name: "Albania", code: "+355", iso: "al", digits: 9, format: [4, 5] },
  { name: "Algeria", code: "+213", iso: "dz", digits: 9, format: [2, 3, 4] },
  { name: "American Samoa", code: "+1684", iso: "as", digits: 7, format: [3, 4] },
  { name: "Andorra", code: "+376", iso: "ad", digits: 6, format: [3, 3] },
  { name: "Angola", code: "+244", iso: "ao", digits: 9, format: [3, 3, 3] },
  { name: "Anguilla", code: "+1264", iso: "ai", digits: 7, format: [3, 4] },
  { name: "Antarctica", code: "+672", iso: "aq", digits: 6, format: [2, 4] },
  { name: "Antigua and Barbuda", code: "+1268", iso: "ag", digits: 7, format: [3, 4] },
  { name: "Argentina", code: "+54", iso: "ar", digits: 10, format: [3, 3, 4] },
  { name: "Armenia", code: "+374", iso: "am", digits: 8, format: [2, 3, 3] },
  { name: "Aruba", code: "+297", iso: "aw", digits: 7, format: [3, 4] },
  { name: "Australia", code: "+61", iso: "au", digits: 9, format: [4, 3, 2] },
  { name: "Austria", code: "+43", iso: "at", digits: 10, format: [3, 3, 4] },
  { name: "Azerbaijan", code: "+994", iso: "az", digits: 9, format: [2, 3, 4] },
  { name: "Bahamas", code: "+1242", iso: "bs", digits: 7, format: [3, 4] },
  { name: "Bahrain", code: "+973", iso: "bh", digits: 8, format: [4, 4] },
  { name: "Bangladesh", code: "+880", iso: "bd", digits: 10, format: [3, 3, 4] },
  { name: "Barbados", code: "+1246", iso: "bb", digits: 7, format: [3, 4] },
  { name: "Belarus", code: "+375", iso: "by", digits: 9, format: [2, 3, 4] },
  { name: "Belgium", code: "+32", iso: "be", digits: 9, format: [3, 2, 2, 2] },
  { name: "Belize", code: "+501", iso: "bz", digits: 7, format: [3, 4] },
  { name: "Benin", code: "+229", iso: "bj", digits: 8, format: [2, 2, 2, 2] },
  { name: "Bermuda", code: "+1441", iso: "bm", digits: 7, format: [3, 4] },
  { name: "Bhutan", code: "+975", iso: "bt", digits: 8, format: [2, 3, 3] },
  { name: "Bolivia", code: "+591", iso: "bo", digits: 8, format: [1, 3, 4] },
  { name: "Bosnia and Herzegovina", code: "+387", iso: "ba", digits: 8, format: [2, 3, 3] },
  { name: "Botswana", code: "+267", iso: "bw", digits: 8, format: [2, 3, 3] },
  { name: "Brazil", code: "+55", iso: "br", digits: 11, format: [2, 5, 4] },
  { name: "British Indian Ocean Territory", code: "+246", iso: "io", digits: 7, format: [3, 4] },
  { name: "British Virgin Islands", code: "+1284", iso: "vg", digits: 7, format: [3, 4] },
  { name: "Brunei", code: "+673", iso: "bn", digits: 7, format: [3, 4] },
  { name: "Bulgaria", code: "+359", iso: "bg", digits: 9, format: [3, 3, 3] },
  { name: "Burkina Faso", code: "+226", iso: "bf", digits: 8, format: [2, 2, 2, 2] },
  { name: "Burundi", code: "+257", iso: "bi", digits: 8, format: [2, 2, 2, 2] },
  { name: "Cambodia", code: "+855", iso: "kh", digits: 9, format: [2, 3, 4] },
  { name: "Cameroon", code: "+237", iso: "cm", digits: 9, format: [2, 2, 2, 3] },
  { name: "Canada", code: "+1", iso: "ca", digits: 10, format: [3, 3, 4] },
  { name: "Cape Verde", code: "+238", iso: "cv", digits: 7, format: [3, 4] },
  { name: "Cayman Islands", code: "+1345", iso: "ky", digits: 7, format: [3, 4] },
  { name: "Central African Republic", code: "+236", iso: "cf", digits: 8, format: [2, 2, 2, 2] },
  { name: "Chad", code: "+235", iso: "td", digits: 8, format: [2, 2, 2, 2] },
  { name: "Chile", code: "+56", iso: "cl", digits: 9, format: [1, 4, 4] },
  { name: "China", code: "+86", iso: "cn", digits: 11, format: [3, 4, 4] },
  { name: "Christmas Island", code: "+61", iso: "cx", digits: 9, format: [4, 3, 2] },
  { name: "Cocos Islands", code: "+61", iso: "cc", digits: 9, format: [4, 3, 2] },
  { name: "Colombia", code: "+57", iso: "co", digits: 10, format: [3, 3, 4] },
  { name: "Comoros", code: "+269", iso: "km", digits: 7, format: [3, 4] },
  { name: "Congo", code: "+242", iso: "cg", digits: 9, format: [1, 4, 4] },
  { name: "Congo (Democratic Republic)", code: "+243", iso: "cd", digits: 9, format: [3, 3, 3] },
  { name: "Cook Islands", code: "+682", iso: "ck", digits: 5, format: [2, 3] },
  { name: "Costa Rica", code: "+506", iso: "cr", digits: 8, format: [4, 4] },
  { name: "Cote d'Ivoire", code: "+225", iso: "ci", digits: 10, format: [2, 2, 2, 2, 2] },
  { name: "Croatia", code: "+385", iso: "hr", digits: 9, format: [2, 3, 4] },
  { name: "Cuba", code: "+53", iso: "cu", digits: 8, format: [1, 3, 4] },
  { name: "Cyprus", code: "+357", iso: "cy", digits: 8, format: [2, 3, 3] },
  { name: "Czech Republic", code: "+420", iso: "cz", digits: 9, format: [3, 3, 3] },
  { name: "Denmark", code: "+45", iso: "dk", digits: 8, format: [2, 2, 2, 2] },
  { name: "Djibouti", code: "+253", iso: "dj", digits: 8, format: [2, 2, 2, 2] },
  { name: "Dominica", code: "+1767", iso: "dm", digits: 7, format: [3, 4] },
  { name: "Dominican Republic", code: "+1809", iso: "do", digits: 7, format: [3, 4] },
  { name: "Ecuador", code: "+593", iso: "ec", digits: 9, format: [2, 3, 4] },
  { name: "Egypt", code: "+20", iso: "eg", digits: 10, format: [2, 4, 4] },
  { name: "El Salvador", code: "+503", iso: "sv", digits: 8, format: [4, 4] },
  { name: "Equatorial Guinea", code: "+240", iso: "gq", digits: 9, format: [3, 3, 3] },
  { name: "Eritrea", code: "+291", iso: "er", digits: 7, format: [1, 2, 4] },
  { name: "Estonia", code: "+372", iso: "ee", digits: 8, format: [3, 3, 2] },
  { name: "Ethiopia", code: "+251", iso: "et", digits: 9, format: [2, 3, 4] },
  { name: "Falkland Islands", code: "+500", iso: "fk", digits: 5, format: [3, 2] },
  { name: "Faroe Islands", code: "+298", iso: "fo", digits: 6, format: [3, 3] },
  { name: "Fiji", code: "+679", iso: "fj", digits: 7, format: [3, 4] },
  { name: "Finland", code: "+358", iso: "fi", digits: 10, format: [3, 3, 4] },
  { name: "France", code: "+33", iso: "fr", digits: 9, format: [1, 2, 2, 2, 2] },
  { name: "French Guiana", code: "+594", iso: "gf", digits: 9, format: [3, 2, 2, 2] },
  { name: "French Polynesia", code: "+689", iso: "pf", digits: 8, format: [2, 2, 2, 2] },
  { name: "Gabon", code: "+241", iso: "ga", digits: 8, format: [2, 2, 2, 2] },
  { name: "Gambia", code: "+220", iso: "gm", digits: 7, format: [3, 4] },
  { name: "Georgia", code: "+995", iso: "ge", digits: 9, format: [3, 2, 2, 2] },
  { name: "Germany", code: "+49", iso: "de", digits: 11, format: [3, 3, 4, 1] },
  { name: "Ghana", code: "+233", iso: "gh", digits: 9, format: [2, 3, 4] },
  { name: "Gibraltar", code: "+350", iso: "gi", digits: 8, format: [3, 5] },
  { name: "Greece", code: "+30", iso: "gr", digits: 10, format: [3, 3, 4] },
  { name: "Greenland", code: "+299", iso: "gl", digits: 6, format: [2, 2, 2] },
  { name: "Grenada", code: "+1473", iso: "gd", digits: 7, format: [3, 4] },
  { name: "Guadeloupe", code: "+590", iso: "gp", digits: 9, format: [3, 2, 2, 2] },
  { name: "Guam", code: "+1671", iso: "gu", digits: 7, format: [3, 4] },
  { name: "Guatemala", code: "+502", iso: "gt", digits: 8, format: [4, 4] },
  { name: "Guinea", code: "+224", iso: "gn", digits: 9, format: [3, 2, 2, 2] },
  { name: "Guinea-Bissau", code: "+245", iso: "gw", digits: 7, format: [3, 4] },
  { name: "Guyana", code: "+592", iso: "gy", digits: 7, format: [3, 4] },
  { name: "Haiti", code: "+509", iso: "ht", digits: 8, format: [2, 2, 2, 2] },
  { name: "Honduras", code: "+504", iso: "hn", digits: 8, format: [4, 4] },
  { name: "Hong Kong", code: "+852", iso: "hk", digits: 8, format: [4, 4] },
  { name: "Hungary", code: "+36", iso: "hu", digits: 9, format: [2, 3, 4] },
  { name: "Iceland", code: "+354", iso: "is", digits: 7, format: [3, 4] },
  { name: "India", code: "+91", iso: "in", digits: 10, format: [5, 5] },
  { name: "Indonesia", code: "+62", iso: "id", digits: 10, format: [3, 4, 3] },
  { name: "Iran", code: "+98", iso: "ir", digits: 10, format: [3, 3, 4] },
  { name: "Iraq", code: "+964", iso: "iq", digits: 10, format: [3, 3, 4] },
  { name: "Ireland", code: "+353", iso: "ie", digits: 9, format: [2, 3, 4] },
  { name: "Israel", code: "+972", iso: "il", digits: 9, format: [1, 3, 3, 2] },
  { name: "Italy", code: "+39", iso: "it", digits: 10, format: [3, 3, 4] },
  { name: "Jamaica", code: "+1876", iso: "jm", digits: 7, format: [3, 4] },
  { name: "Japan", code: "+81", iso: "jp", digits: 10, format: [3, 4, 3] },
  { name: "Jordan", code: "+962", iso: "jo", digits: 9, format: [2, 3, 4] },
  { name: "Kazakhstan", code: "+7", iso: "kz", digits: 10, format: [3, 3, 4] },
  { name: "Kenya", code: "+254", iso: "ke", digits: 10, format: [3, 3, 4] },
  { name: "Kiribati", code: "+686", iso: "ki", digits: 8, format: [2, 3, 3] },
  { name: "Kuwait", code: "+965", iso: "kw", digits: 8, format: [4, 4] },
  { name: "Kyrgyzstan", code: "+996", iso: "kg", digits: 9, format: [3, 3, 3] },
  { name: "Laos", code: "+856", iso: "la", digits: 10, format: [2, 3, 5] },
  { name: "Latvia", code: "+371", iso: "lv", digits: 8, format: [2, 3, 3] },
  { name: "Lebanon", code: "+961", iso: "lb", digits: 8, format: [2, 3, 3] },
  { name: "Lesotho", code: "+266", iso: "ls", digits: 8, format: [2, 3, 3] },
  { name: "Liberia", code: "+231", iso: "lr", digits: 8, format: [2, 3, 3] },
  { name: "Libya", code: "+218", iso: "ly", digits: 10, format: [2, 3, 3, 2] },
  { name: "Liechtenstein", code: "+423", iso: "li", digits: 7, format: [3, 2, 2] },
  { name: "Lithuania", code: "+370", iso: "lt", digits: 8, format: [3, 2, 3] },
  { name: "Luxembourg", code: "+352", iso: "lu", digits: 9, format: [3, 3, 3] },
  { name: "Macao", code: "+853", iso: "mo", digits: 8, format: [4, 4] },
  { name: "Macedonia", code: "+389", iso: "mk", digits: 8, format: [2, 3, 3] },
  { name: "Madagascar", code: "+261", iso: "mg", digits: 9, format: [2, 2, 2, 3] },
  { name: "Malawi", code: "+265", iso: "mw", digits: 9, format: [1, 4, 4] },
  { name: "Malaysia", code: "+60", iso: "my", digits: 9, format: [3, 3, 3] },
  { name: "Maldives", code: "+960", iso: "mv", digits: 7, format: [3, 4] },
  { name: "Mali", code: "+223", iso: "ml", digits: 8, format: [2, 2, 2, 2] },
  { name: "Malta", code: "+356", iso: "mt", digits: 8, format: [4, 4] },
  { name: "Marshall Islands", code: "+692", iso: "mh", digits: 7, format: [3, 4] },
  { name: "Martinique", code: "+596", iso: "mq", digits: 9, format: [3, 2, 2, 2] },
  { name: "Mauritania", code: "+222", iso: "mr", digits: 8, format: [2, 2, 2, 2] },
  { name: "Mauritius", code: "+230", iso: "mu", digits: 8, format: [4, 4] },
  { name: "Mayotte", code: "+262", iso: "yt", digits: 9, format: [3, 2, 2, 2] },
  { name: "Mexico", code: "+52", iso: "mx", digits: 10, format: [3, 3, 4] },
  { name: "Micronesia", code: "+691", iso: "fm", digits: 7, format: [3, 4] },
  { name: "Moldova", code: "+373", iso: "md", digits: 8, format: [2, 3, 3] },
  { name: "Monaco", code: "+377", iso: "mc", digits: 8, format: [3, 3, 2] },
  { name: "Mongolia", code: "+976", iso: "mn", digits: 8, format: [2, 2, 4] },
  { name: "Montenegro", code: "+382", iso: "me", digits: 8, format: [2, 3, 3] },
  { name: "Montserrat", code: "+1664", iso: "ms", digits: 7, format: [3, 4] },
  { name: "Morocco", code: "+212", iso: "ma", digits: 9, format: [2, 3, 4] },
  { name: "Mozambique", code: "+258", iso: "mz", digits: 9, format: [2, 3, 4] },
  { name: "Myanmar", code: "+95", iso: "mm", digits: 9, format: [2, 3, 4] },
  { name: "Namibia", code: "+264", iso: "na", digits: 9, format: [2, 3, 4] },
  { name: "Nauru", code: "+674", iso: "nr", digits: 7, format: [3, 4] },
  { name: "Nepal", code: "+977", iso: "np", digits: 10, format: [3, 3, 4] },
  { name: "Netherlands", code: "+31", iso: "nl", digits: 9, format: [3, 3, 3] },
  { name: "New Caledonia", code: "+687", iso: "nc", digits: 6, format: [2, 2, 2] },
  { name: "New Zealand", code: "+64", iso: "nz", digits: 9, format: [2, 3, 4] },
  { name: "Nicaragua", code: "+505", iso: "ni", digits: 8, format: [4, 4] },
  { name: "Niger", code: "+227", iso: "ne", digits: 8, format: [2, 3, 3] },
  { name: "Nigeria", code: "+234", iso: "ng", digits: 10, format: [3, 3, 4] },
  { name: "Niue", code: "+683", iso: "nu", digits: 4, format: [4] },
  { name: "Norfolk Island", code: "+672", iso: "nf", digits: 6, format: [3, 3] },
  { name: "North Korea", code: "+850", iso: "kp", digits: 10, format: [2, 3, 3, 2] },
  { name: "Northern Mariana Islands", code: "+1670", iso: "mp", digits: 7, format: [3, 4] },
  { name: "Norway", code: "+47", iso: "no", digits: 8, format: [3, 2, 3] },
  { name: "Oman", code: "+968", iso: "om", digits: 8, format: [4, 4] },
  { name: "Pakistan", code: "+92", iso: "pk", digits: 10, format: [3, 3, 4] },
  { name: "Palau", code: "+680", iso: "pw", digits: 7, format: [3, 4] },
  { name: "Palestine", code: "+970", iso: "ps", digits: 9, format: [2, 3, 4] },
  { name: "Panama", code: "+507", iso: "pa", digits: 8, format: [4, 4] },
  { name: "Papua New Guinea", code: "+675", iso: "pg", digits: 8, format: [3, 5] },
  { name: "Paraguay", code: "+595", iso: "py", digits: 9, format: [2, 3, 4] },
  { name: "Peru", code: "+51", iso: "pe", digits: 9, format: [2, 3, 4] },
  { name: "Philippines", code: "+63", iso: "ph", digits: 10, format: [3, 3, 4] },
  { name: "Poland", code: "+48", iso: "pl", digits: 9, format: [3, 3, 3] },
  { name: "Portugal", code: "+351", iso: "pt", digits: 9, format: [3, 3, 3] },
  { name: "Puerto Rico", code: "+1787", iso: "pr", digits: 7, format: [3, 4] },
  { name: "Qatar", code: "+974", iso: "qa", digits: 8, format: [4, 4] },
  { name: "Reunion", code: "+262", iso: "re", digits: 9, format: [3, 2, 2, 2] },
  { name: "Romania", code: "+40", iso: "ro", digits: 10, format: [3, 3, 4] },
  { name: "Russia", code: "+7", iso: "ru", digits: 10, format: [3, 3, 4] },
  { name: "Rwanda", code: "+250", iso: "rw", digits: 9, format: [3, 3, 3] },
  { name: "Saint Helena", code: "+290", iso: "sh", digits: 4, format: [4] },
  { name: "Saint Kitts and Nevis", code: "+1869", iso: "kn", digits: 7, format: [3, 4] },
  { name: "Saint Lucia", code: "+1758", iso: "lc", digits: 7, format: [3, 4] },
  { name: "Saint Pierre and Miquelon", code: "+508", iso: "pm", digits: 6, format: [3, 3] },
  { name: "Saint Vincent and the Grenadines", code: "+1784", iso: "vc", digits: 7, format: [3, 4] },
  { name: "Samoa", code: "+685", iso: "ws", digits: 7, format: [2, 5] },
  { name: "San Marino", code: "+378", iso: "sm", digits: 10, format: [2, 2, 2, 4] },
  { name: "Sao Tome and Principe", code: "+239", iso: "st", digits: 7, format: [3, 4] },
  { name: "Saudi Arabia", code: "+966", iso: "sa", digits: 9, format: [3, 3, 3] },
  { name: "Senegal", code: "+221", iso: "sn", digits: 9, format: [3, 2, 2, 2] },
  { name: "Serbia", code: "+381", iso: "rs", digits: 9, format: [2, 3, 4] },
  { name: "Seychelles", code: "+248", iso: "sc", digits: 7, format: [2, 2, 3] },
  { name: "Sierra Leone", code: "+232", iso: "sl", digits: 8, format: [2, 3, 3] },
  { name: "Singapore", code: "+65", iso: "sg", digits: 8, format: [4, 4] },
  { name: "Slovakia", code: "+421", iso: "sk", digits: 9, format: [3, 3, 3] },
  { name: "Slovenia", code: "+386", iso: "si", digits: 8, format: [2, 3, 3] },
  { name: "Solomon Islands", code: "+677", iso: "sb", digits: 7, format: [3, 4] },
  { name: "Somalia", code: "+252", iso: "so", digits: 8, format: [2, 3, 3] },
  { name: "South Africa", code: "+27", iso: "za", digits: 9, format: [2, 3, 4] },
  { name: "South Korea", code: "+82", iso: "kr", digits: 10, format: [2, 4, 4] },
  { name: "Spain", code: "+34", iso: "es", digits: 9, format: [3, 3, 3] },
  { name: "Sri Lanka", code: "+94", iso: "lk", digits: 9, format: [2, 3, 4] },
  { name: "Sudan", code: "+249", iso: "sd", digits: 9, format: [2, 3, 4] },
  { name: "Suriname", code: "+597", iso: "sr", digits: 7, format: [3, 4] },
  { name: "Swaziland", code: "+268", iso: "sz", digits: 8, format: [2, 3, 3] },
  { name: "Sweden", code: "+46", iso: "se", digits: 9, format: [3, 2, 2, 2] },
  { name: "Switzerland", code: "+41", iso: "ch", digits: 9, format: [2, 3, 2, 2] },
  { name: "Syria", code: "+963", iso: "sy", digits: 9, format: [2, 3, 4] },
  { name: "Taiwan", code: "+886", iso: "tw", digits: 9, format: [2, 4, 3] },
  { name: "Tajikistan", code: "+992", iso: "tj", digits: 9, format: [3, 3, 3] },
  { name: "Tanzania", code: "+255", iso: "tz", digits: 9, format: [2, 3, 4] },
  { name: "Thailand", code: "+66", iso: "th", digits: 9, format: [2, 3, 4] },
  { name: "Timor-Leste", code: "+670", iso: "tl", digits: 8, format: [3, 5] },
  { name: "Togo", code: "+228", iso: "tg", digits: 8, format: [2, 3, 3] },
  { name: "Tokelau", code: "+690", iso: "tk", digits: 4, format: [4] },
  { name: "Tonga", code: "+676", iso: "to", digits: 5, format: [5] },
  { name: "Trinidad and Tobago", code: "+1868", iso: "tt", digits: 7, format: [3, 4] },
  { name: "Tunisia", code: "+216", iso: "tn", digits: 8, format: [2, 3, 3] },
  { name: "Turkey", code: "+90", iso: "tr", digits: 10, format: [3, 3, 4] },
  { name: "Turkmenistan", code: "+993", iso: "tm", digits: 8, format: [2, 3, 3] },
  { name: "Turks and Caicos Islands", code: "+1649", iso: "tc", digits: 7, format: [3, 4] },
  { name: "Tuvalu", code: "+688", iso: "tv", digits: 5, format: [2, 3] },
  { name: "Uganda", code: "+256", iso: "ug", digits: 9, format: [3, 3, 3] },
  { name: "Ukraine", code: "+380", iso: "ua", digits: 9, format: [2, 3, 4] },
  { name: "United Kingdom", code: "+44", iso: "gb", digits: 10, format: [4, 3, 3] },
  { name: "United States", code: "+1", iso: "us", digits: 10, format: [3, 3, 4] },
  { name: "Uruguay", code: "+598", iso: "uy", digits: 8, format: [2, 3, 3] },
  { name: "Uzbekistan", code: "+998", iso: "uz", digits: 9, format: [2, 3, 4] },
  { name: "Vanuatu", code: "+678", iso: "vu", digits: 7, format: [3, 4] },
  { name: "Vatican City", code: "+379", iso: "va", digits: 10, format: [2, 3, 5] },
  { name: "Venezuela", code: "+58", iso: "ve", digits: 10, format: [3, 3, 4] },
  { name: "Vietnam", code: "+84", iso: "vn", digits: 10, format: [3, 3, 4] },
  { name: "Virgin Islands (US)", code: "+1340", iso: "vi", digits: 7, format: [3, 4] },
  { name: "Wallis and Futuna", code: "+681", iso: "wf", digits: 6, format: [2, 2, 2] },
  { name: "Yemen", code: "+967", iso: "ye", digits: 9, format: [2, 3, 4] },
  { name: "Zambia", code: "+260", iso: "zm", digits: 9, format: [2, 3, 4] },
  { name: "Zimbabwe", code: "+263", iso: "zw", digits: 9, format: [2, 3, 4] }
];  
